export default __webpack_public_path__ + "static/media/left.61c80419.png";